import { RootState } from '@reducers';

export const selectPersonalAccidentQuoteBuyRoute = (state: RootState) => state.personalAccidentQuoteBuyRouteReducer;
